import { FOUNTAIN_ACTS_ROOT } from '@/data/entities/acts';
import { BITS_ROOT } from '@/data/entities/bits';
import { CHARACTERS_ROOT } from '@/data/entities/characters';
import { EPISODES_ROOT } from '@/data/entities/episodes';
import { FEATURES_ROOT } from '@/data/entities/features';
import { FOUNTAIN_SCENES_ROOT } from '@/data/entities/fountainScenes';
import { FOUNTAIN_FRAGMENTS_ROOT } from '@/data/entities/fragments';
import { PROJECTS_ROOT } from '@/data/entities/projects';
import { SCENES_ROOT } from '@/data/entities/scenes';
import { TAGS_ROOT } from '@/data/entities/tags';

/**
 * All entity roots the editor bulk-refetches, sourced from the entity files
 * (ADR 0010: roots are declared once, never re-typed as literals). The former
 * bare 'fountain' prefix is expressed as its three concrete entity roots.
 */
export const EDITOR_ENTITY_ROOTS: readonly (readonly string[])[] = [
    SCENES_ROOT,
    EPISODES_ROOT,
    CHARACTERS_ROOT,
    FOUNTAIN_ACTS_ROOT,
    FOUNTAIN_FRAGMENTS_ROOT,
    FOUNTAIN_SCENES_ROOT,
    BITS_ROOT,
    FEATURES_ROOT,
    TAGS_ROOT,
    PROJECTS_ROOT,
];
